import LoginPage from './login'
import RecoverPasswordPage from './recover-password'

export default {
    // prettier-ignore
    login: LoginPage,
    recover: RecoverPasswordPage
}
